import { Component, Input, OnInit } from '@angular/core';
import { getDownloadURL, listAll, ref, Storage } from '@angular/fire/storage';
import { ModalController } from "@ionic/angular";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { FileService } from "../../shared/file.service";
import { VideoPlayerModalComponent } from "../video-player-modal/video-player-modal.component";

@Component({
  selector: 'app-info-despagination-modal',
  templateUrl: './info-despagination-modal.component.html',
  styleUrls: ['./info-despagination-modal.component.scss'],
  standalone: false
})
export class InfoDespaginationModalComponent implements OnInit {
  @Input() fileSettings;
  @Input() currentCoverType;
  @Input() docColor: boolean = true;
  videoList$;
  constructor(public fileService: FileService, private storage: Storage, private modalController: ModalController) {
  }

  ngOnInit() {
    this.videoList$ = this.getVideoList();
  }

  // TODO: To helper (dont know which one)
  getCoverTypeImage(despagination: boolean) {
    const result = 'Color' + (despagination ? '1Side' : '2Side') + '1Page' +
      '-' + (this.docColor ? 'Color' : 'Black') + '2Side1Page.png';
    return `assets/images/coverType/${result}`;
  }
  getVideoList(): Observable<string[]> {
    const storageRef = ref(this.storage, `videos/cover-types`);
    return from(listAll(storageRef)).pipe(
      map((result) => result.items.map((item) => item.name))
    );
  }
  videoExists(videoList, coverType) {
    return videoList.includes(this.getCoverTypeFullId(coverType) + '.mp4');
  }

  async showVideo(event, coverType) {
    event.stopPropagation();

    const storageRef = ref(this.storage, `videos/cover-types/${this.getCoverTypeFullId(coverType) + '.mp4'}`);
    const videoUrl = await getDownloadURL(storageRef);

    const modal = await this.modalController.create({
      component: VideoPlayerModalComponent,
      cssClass: 'auto-height',
      componentProps: {
        videoUrl: videoUrl,
      }
    });

    await modal.present();
  }

  // TODO: To helper (dont know which one)
  getCoverTypeFullId(coverType) {
    return coverType.id + '-' +
      (this.fileSettings.docColor ? 'Color' : 'Black') +
      (this.fileSettings.twoSided ? '2' : '1') + 'Side' +
      this.fileSettings.pagesPerSheet + 'Page';
  }
}
